import { graphql } from 'msw';

import { FetchUserQuery } from '@zoopla/user-queries';
import { FetchUserWithTrackedPropertiesQuery } from '../AuthModal/section/SignIn/queries/userWithTrackedProperties.generated';

import {
    baseUser,
    userWithEmptyTrackedProperties,
    userWithTrackedProperties,
    userWithTrackedPropertiesConsented
} from './data/user';
import { GraphQLError } from 'graphql';

export const generateUserHandler = (user: FetchUserQuery['user']) => {
    return graphql.query<FetchUserQuery>('fetchUser', (_, res, ctx) => {
        return res(ctx.data({ user }));
    });
};

export const generateUserWithTrackedPropertiesHandler = (
    user: FetchUserWithTrackedPropertiesQuery['user']
) => {
    return graphql.query<FetchUserWithTrackedPropertiesQuery>(
        'fetchUserWithTrackedProperties',
        (_, res, ctx) => {
            return res(ctx.data({ user }));
        }
    );
};

export const generateUserWithTrackedPropertiesErrorHandler = (
    errorMessage: GraphQLError['message']
) => {
    const graphqlError = new GraphQLError(errorMessage);

    return graphql.query<FetchUserWithTrackedPropertiesQuery>(
        'fetchUserWithTrackedProperties',
        (_, res, ctx) => {
            return res(ctx.errors([graphqlError]));
        }
    );
};

export const defaultUserHandler = generateUserHandler(baseUser);

export const userWithEmptyTrackedPropertiesHandler =
    generateUserWithTrackedPropertiesHandler(userWithEmptyTrackedProperties);

export const userWithTrackedPropertiesHandler =
    generateUserWithTrackedPropertiesHandler(userWithTrackedProperties);

export const userWithTrackedPropertiesServerErrorHandler =
    generateUserWithTrackedPropertiesErrorHandler('Example error');

export const userWithTrackedPropertiesConsentedHandler =
    generateUserWithTrackedPropertiesHandler(
        userWithTrackedPropertiesConsented
    );
